<div [ngClass]="{ dark: this.themeService.isDark }">
  <p-toast position="bottom-right" key="br" [breakpoints]="{'920px': {width: '100%', right: '0', left: '0'}}"></p-toast>
    <app-session-modal
    *ngIf="showModal"
    [countdown]="countdown"
    [visible]="showModal"
    (stayActive)="onStayActive()"
    (click)="$event.stopPropagation()"
  ></app-session-modal>
  <router-outlet></router-outlet>
  <!-- <app-responsive-helper></app-responsive-helper> -->
</div>
